export const ModalType = {
    RejectionReason: 1
}